import { AxiosInstance } from 'axios';

import TimeSlot, { TimeSlotInit } from '../../domain/entities/TimeSlot';
import securedAxios from '../../utils/secured-axios';
import { buildApiV2Url } from 'src/utils/request-url';

/**
 * NOTE: use coubic v2 api
 */

export class TimeSlotRepository {
  private api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this.api = api;
  }

  public async Find(
    merchantId: string,
    bookingPageId: string,
    timeSlotId: string,
  ): Promise<TimeSlot> {
    const path = buildApiV2Url(
      `/merchants/${merchantId}/booking_pages/${bookingPageId}/time_slots/${timeSlotId}`,
    );

    return this.api.get<{ data: TimeSlotInit }>(path).then((response) => {
      return new TimeSlot(response.data.data);
    });
  }
}

export default new TimeSlotRepository(securedAxios);
